import React from "react";
import { IonButton, IonIcon, IonText } from "@ionic/react";
import { alertCircleOutline, refresh } from "ionicons/icons";

type ErrorMessageProps = {
  errorMsg?: string;
};
const OneErrorMessage: React.FC<ErrorMessageProps> = ({ errorMsg }) => {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column",
        gap: 3,
      }}
    >
      <IonIcon
        icon={alertCircleOutline}
        color="danger"
        style={{ fontSize: "var(--one-font-size-9)" }}
      />
      <IonText color="danger">
        <p
          className="ion-text-center ion-no-margin"
          style={{ fontSize: "var(--one-font-size-8)" }}
        >
          {errorMsg || `Oops! Something went wrong.`}
        </p>
      </IonText>
      <div style={{ marginTop: 5 }}></div>
    </div>
  );
};

export default OneErrorMessage;
